<!-- Button -->
<!-- <button mat-icon-button [matMenuTriggerFor]="userActions">
    <img *ngIf="user" class="w-7 h-7 min-w-7 min-h-7 max-w-7 rounded-full object-cover object-top"
        [src]="user?.imageUrl"
        [alt]="user?.name">
</button> -->
<div class="fuse-vertical-navigation-item-wrapper cursor-pointer hover:bg-transparent" [matMenuTriggerFor]="userActions">
    <img *ngIf="user" class="w-7 h-7 min-w-7 min-h-7 max-w-7 rounded-full object-cover object-top"
        [src]="user?.imageUrl"
        [alt]="user?.name">
</div>


<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <!-- <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span class="font-semibold text-primary text-md">{{user?.name}}</span>
            <span class="mt-1.5 text-md font-medium text-primary-500">{{user?.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider> -->
    <button mat-menu-item (click)="moveToProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'" ></mat-icon>
        <span>{{"GENERAL.PROFILE" | translate}}</span>
    </button>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
        <span>{{"GENERAL.SIGN_OUT" | translate}}</span>
    </button>
</mat-menu>